'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversationQueueShift = exports.conversationQueueClear = exports.conversationQueueAppend = exports.conversationProcessingSet = exports.conversationSet = exports.conversationClear = exports.conversationAppend = undefined;

var _conversation = require('../selectors/conversation');

var _types = require('../types');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var conversationAppend = exports.conversationAppend = function conversationAppend(newMessage) {
  return function (dispatch, getState) {
    var conversation = (0, _conversation.conversationGet)(getState());
    newMessage.shown = false;
    newMessage.timestamp = Date.now();

    var newConversation = [].concat(_toConsumableArray(conversation), [newMessage]);

    return dispatch({ payload: newConversation, type: _types.CONVERSATION_SET });
  };
};

var conversationClear = exports.conversationClear = function conversationClear() {
  return function (dispatch) {
    return dispatch({ type: _types.CONVERSATION_CLEAR });
  };
};

var conversationSet = exports.conversationSet = function conversationSet(conversation) {
  return function (dispatch) {
    return dispatch({ payload: conversation, type: _types.CONVERSATION_SET });
  };
};

var conversationProcessingSet = exports.conversationProcessingSet = function conversationProcessingSet(value) {
  return function (dispatch) {
    return dispatch({ payload: value, type: _types.CONVERSATION_PROCESSING_SET });
  };
};

var conversationQueueAppend = exports.conversationQueueAppend = function conversationQueueAppend(newMessage) {
  return function (dispatch, getState) {
    var queue = (0, _conversation.conversationGetQueue)(getState());
    var newQueue = [].concat(_toConsumableArray(queue), [newMessage]);
    return dispatch({ payload: newQueue, type: _types.CONVERSATION_QUEUE_SET });
  };
};

var conversationQueueClear = exports.conversationQueueClear = function conversationQueueClear() {
  return function (dispatch) {
    return dispatch({ type: _types.CONVERSATION_QUEUE_CLEAR });
  };
};

var conversationQueueShift = exports.conversationQueueShift = function conversationQueueShift() {
  return function (dispatch, getState) {
    var queue = (0, _conversation.conversationGetQueue)(getState());
    queue.shift();
    return dispatch({ payload: queue, type: _types.CONVERSATION_QUEUE_SET });
  };
};